// ── Kontorskonfiguration ──────────────────────────────────────────────────────

export const OFFICES = {
  stockholm: {
    displayName: 'Stockholm',
    address: 'Björnstigen 87, Solna',
  },
  gothenburg: {
    displayName: 'Göteborg',
    address: 'Mässans gata 10',
  },
};

// ── Hållplatskonfiguration ────────────────────────────────────────────────────
// id = ResRobot ExtId, tvStation = Trafikverkets stationskod (för tåg)

export const OFFICE_STOPS = {
  stockholm: [
    { id: '740021644', name: 'Bergshamra', subtitle: 'Tunnelbana linje 14', icon: 'metro', walkMins: 3 },
    { id: '740045576', name: 'Bergshamra Bro', subtitle: 'Buss 177, 178, 509, 583', icon: 'bus', walkMins: 5 },
    { id: '740045578', name: 'Bergshamra Gård', subtitle: 'Buss', icon: 'bus', walkMins: 6 },
    { id: '740000781', name: 'Ulriksdal', subtitle: 'Pendeltåg J40/J41/J42', icon: 'train', tvStation: 'Ul', walkMins: 12 },
    { id: '740046196', name: 'Frösundavik', subtitle: 'Flygbussarna · Arlanda', icon: 'bus', walkMins: 10 },
    { id: '740000001', name: 'Stockholm C → Göteborg C', subtitle: 'Regionaltåg', icon: 'train', tvStation: 'Cst', walkMins: null, directionFilter: 'göteborg', maxRows: 5 },
  ],
  gothenburg: [
    { id: '740015578', name: 'Korsvägen', subtitle: 'Spårvagn 2, 6, 8, 13 · Buss 18', icon: 'tram', walkMins: 3 },
    { id: '740098311', name: 'Liseberg', subtitle: 'Spårvagn', icon: 'tram', walkMins: 4 },
    { id: '740025681', name: 'Scandinavium', subtitle: 'Spårvagn', icon: 'tram', walkMins: 7 },
    { id: '740075827', name: 'Liseberg Södra', subtitle: 'Pendeltåg', icon: 'train', tvStation: 'LsS', walkMins: 6 },
    { id: '740000002', name: 'Göteborg C → Stockholm C', subtitle: 'Regionaltåg', icon: 'train', tvStation: 'G', walkMins: 20, directionFilter: 'stockholm', maxRows: 5 },
  ],
};

// ── Linjefärger ───────────────────────────────────────────────────────────────

export const LINE_COLORS = {
  // SL Tunnelbana
  '10': '#0066B3', '11': '#0066B3',
  '13': '#E30613', '14': '#E30613',
  '17': '#168C44', '18': '#168C44', '19': '#168C44',
  // SL Pendeltåg
  '35': '#E58600', '36': '#E58600', '37': '#E58600',
  '38': '#E58600', '40': '#E58600', '41': '#E58600',
  '42': '#E58600', '43': '#E58600', '44': '#E58600',
  '45': '#E58600',
};

// Västtrafik spårvagnslinjer Göteborg – officiella linjefärger
const TRAM_COLORS_GBG = {
  '1':  '#808080', // vit/grå (vit ej läsbar med vit text)
  '2':  '#C9A000', // gul
  '3':  '#3A82C4', // blå
  '4':  '#2E8B57', // grön
  '5':  '#C0392B', // röd
  '6':  '#E8721D', // orange
  '7':  '#7B4B2A', // brun
  '8':  '#8E44AD', // lila
  '9':  '#5B8FBF', // ljusblå
  '10': '#89A800', // gulgrön
  '11': '#111111', // svart
  '12': '#00A8B5', // cyan
  '13': '#5C7A8C', // blågrå
  '14': '#8B79C4', // lavendel
  '15': '#D81B7A', // rosa
  '16': '#1A8A7A', // teal
  '17': '#8B1A1A', // mörkröd
  '18': '#7A7A00', // oliv
  '19': '#6A1B9A', // mörkviolett
  '20': '#6B6B6B', // grå
  '21': '#9A9A9A', // ljusgrå
};

export function getLineColor(lineNumber, category) {
  const cat = (category || '').toUpperCase();
  const num = (lineNumber || '').trim();

  // Spårvagn: använd Göteborg-paletten (undvik krockar med T-bana)
  if (cat === 'S' || cat.includes('TRAM') || cat.includes('SPÅRVÄG') || cat.includes('SPÅRVAGN')) {
    return TRAM_COLORS_GBG[num] || '#7C3AED';
  }

  // Försök med bara sifferdelen (t.ex. "Tunnelbana 14" → "14")
  const numOnly = num.match(/\d+$/)?.[0];
  if (numOnly && LINE_COLORS[numOnly]) return LINE_COLORS[numOnly];
  if (LINE_COLORS[num]) return LINE_COLORS[num];

  const ln = num.toLowerCase();
  if (ln.includes('tunnelbana') || ln.includes('t-bana')) return '#0066B3';
  if (ln.includes('spårvagn') || ln.includes('tram')) return '#7C3AED';
  if (ln.includes('pendeltåg') || ln.includes('pendeltag')) return '#E58600';

  if (cat === 'U' || cat.includes('METRO') || cat.includes('TUNNELBANA')) return '#0066B3';
  if (cat === 'P' || cat.includes('PENDEL')) return '#E58600';
  if (cat === 'B' || cat.includes('BUS')) return '#1d4ed8';
  if (cat === 'J' || cat.includes('TRAIN') || cat.includes('TÅG')) return '#B45309';
  if (cat === 'F' || cat.includes('FERRY') || cat.includes('FÄRJA')) return '#0891B2';
  return '#64748b';
}

// ── Linjeetiketter ────────────────────────────────────────────────────────────

// "Länstrafik - Spårväg 6" → { operator: "Länstrafik", line: "6" }
// "509" → { operator: null, line: "509" }
export function parseLineLabel(lineNumber) {
  const m = (lineNumber || '').match(/^(.+?)\s*-\s*(.+)$/);
  if (m) {
    const operator = m[1].trim();
    let line = m[2].trim();
    // Ta bort trafikslagets namn — färgen visar redan typen
    const prefix = line.match(/^(Tunnelbana|Spårvagn|Spårväg|Buss|Pendeltåg|Tåg|Metro|Tram|Trafik)\s+(.+)$/i);
    if (prefix) line = prefix[2];
    return { operator, line, trainType: null };
  }
  // Tåg med typ och nummer: "Regional Tåg 170", "Snabbtåg 428"
  const trainMatch = (lineNumber || '').match(/^([A-Za-zÅÄÖåäö].*?)\s+(\d+)$/);
  if (trainMatch) {
    return { operator: null, line: trainMatch[2], trainType: trainMatch[1].trim() };
  }
  return { operator: null, line: lineNumber || '?', trainType: null };
}

// Mappar kategori till visningsetikett för typ-chip
export function getTypeLabel(category) {
  const c = (category || '').toUpperCase();
  if (c === 'U' || c.includes('METRO') || c.includes('TUNNELBANA')) return 'T-bana';
  if (c === 'S' || c.includes('TRAM') || c.includes('SPÅRVÄG') || c.includes('SPÅRVAGN')) return 'Spårvagn';
  if (c === 'P' || c.includes('PENDEL')) return 'Pendeltåg';
  if (c === 'F' || c.includes('FERRY') || c.includes('FÄRJA') || c.includes('BOAT')) return 'Färja';
  if (c === 'J' || c.includes('TRAIN') || c.includes('TÅG')) return 'Tåg';
  return 'Buss';
}

// Mappar kategori till ikon-typ
export function categoryToIcon(category) {
  const c = (category || '').toUpperCase();
  if (c === 'U' || c.includes('METRO') || c.includes('TUNNELBANA')) return 'metro';
  if (c === 'S' || c.includes('TRAM') || c.includes('SPÅRVÄG') || c.includes('SPÅRVAGN')) return 'tram';
  if (c === 'P' || c.includes('PENDEL')) return 'train';
  if (c === 'F' || c.includes('FERRY') || c.includes('FÄRJA') || c.includes('BOAT')) return 'ferry';
  if (c === 'J' || c.includes('TRAIN') || c.includes('TÅG')) return 'train';
  return 'bus';
}

// ── Härled kontor från basort ─────────────────────────────────────────────────
// Mappar fritext som "Stockholm", "Göteborg", "Gbg" till en OFFICES-nyckel.
// Returnerar null om ingen matchning – avgångstavlan faller då tillbaka på
// ett sparat override eller 'stockholm' som default.

export function officeFromBasort(basort) {
  if (!basort) return null;
  const b = basort.toLowerCase().trim();
  if (b.includes('stockholm') || b.includes('sthlm') || b === 'sthlm' || b === 'sth') return 'stockholm';
  if (b.includes('göteborg') || b.includes('goteborg') || b.includes('gbg') || b === 'gbg') return 'gothenburg';
  return null;
}

// ── API-anrop (via Netlify /api/ proxy) ───────────────────────────────────────

const FN = '/.netlify/functions';

export async function fetchDepartures(stopId, maxJourneys = 30) {
  const res = await fetch(`${FN}/resrobot?id=${encodeURIComponent(stopId)}&maxJourneys=${maxJourneys}`);
  if (!res.ok) throw new Error(`ResRobot HTTP ${res.status}`);
  const data = await res.json();
  return data.Departure || [];
}

export async function searchLocation(query) {
  const res = await fetch(`${FN}/stops?input=${encodeURIComponent(query)}`);
  if (!res.ok) throw new Error(`Stops HTTP ${res.status}`);
  const data = await res.json();
  // ResRobot v2 returnerar StopLocation[], v2.1 returnerar stopLocationOrCoordLocation[]
  if (Array.isArray(data.StopLocation)) return data.StopLocation;
  if (Array.isArray(data.stopLocationOrCoordLocation)) {
    return data.stopLocationOrCoordLocation
      .filter(item => item.StopLocation)
      .map(item => item.StopLocation);
  }
  return [];
}

export async function fetchTrainDepartures(tvStation) {
  const res = await fetch(`${FN}/trafikverket?station=${encodeURIComponent(tvStation)}`);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail ? `Trafikverket ${res.status}: ${data.detail}` : `Trafikverket HTTP ${res.status}`);
  }
  const data = await res.json();
  return data.announcements || [];
}

// ── Tolka ResRobot-avgångar ───────────────────────────────────────────────────

// Detekterar kategori från ResRobot Product-data.
// Prioritetsordning: produktnamn (textbaserad) → Hafas catCode (6=tram,7=bus,8=färja)
function detectCategory(dep) {
  const pn = (dep.Product?.[0]?.name || '').toLowerCase();
  if (pn.includes('tunnelbana') || pn.includes('t-bana')) return 'U';
  if (pn.includes('spårvagn') || pn.includes('spårväg') || pn.includes('tram')) return 'S';
  if (pn.includes('pendeltåg') || pn.includes('pendeltag') || pn.includes('pendel')) return 'P';
  if (pn.includes('snabbtåg') || pn.includes('regionaltåg') || pn.includes('regional tåg')) return 'J';
  if (pn.includes('tåg') || pn.includes('train')) return 'J';
  if (pn.includes('färja') || pn.includes('ferry') || pn.includes('båt')) return 'F';
  // Hafas numeriska catCode: 2=regional, 3=expresståg, 4=pendel/lokaltåg, 5=metro, 6=spårvagn, 7=buss, 8=färja
  const hafas = { '2': 'J', '3': 'J', '4': 'P', '5': 'U', '6': 'S', '7': 'B', '8': 'F' };
  const code = dep.Product?.[0]?.catCode || '';
  if (hafas[code]) return hafas[code];
  return dep.category || 'B';
}

export function parseDepartures(rawDeps) {
  const groups = {};
  const now = Date.now();

  for (const dep of rawDeps) {
    const lineNum = (dep.transportNumber || dep.name || '?').trim();
    const dir = dep.direction || '';
    const key = `${lineNum}__${dir}`;
    if (!groups[key]) {
      groups[key] = {
        lineNumber: lineNum,
        direction: dir,
        category: detectCategory(dep),
        departures: [],
      };
    }
    const timeStr = dep.rtTime || dep.time;
    const dateStr = dep.rtDate || dep.date;
    if (!timeStr || !dateStr) continue;
    const depMs = new Date(`${dateStr}T${timeStr}`).getTime();
    const mins = Math.round((depMs - now) / 60000);
    if (mins > -2 && mins < 120) {
      groups[key].departures.push(mins);
    }
  }

  return Object.values(groups)
    .filter(g => g.departures.length > 0)
    .sort((a, b) => (a.departures[0] ?? 99) - (b.departures[0] ?? 99));
}

// ── Tolka Trafikverket-avgångar ───────────────────────────────────────────────
// Returnerar normaliserade rader för visning i StopCard.

export function parseTrainAnnouncements(announcements) {
  const now = Date.now();
  const rows = [];

  for (const ann of announcements) {
    const advertised = ann.AdvertisedTimeAtLocation;
    const estimated = ann.EstimatedTimeAtLocation;
    if (!advertised) continue;

    const advMs = new Date(advertised).getTime();
    const estMs = estimated ? new Date(estimated).getTime() : advMs;
    const minsAdv = Math.round((advMs - now) / 60000);
    const minsEst = Math.round((estMs - now) / 60000);
    if (minsAdv < -2 || minsAdv > 120) continue;

    const delayMins = Math.round((estMs - advMs) / 60000);
    const trainId = ann.AdvertisedTrainIdent || '';
    const toLocation = ann.ToLocation?.[0]?.LocationName || '';
    const track = ann.Track || '';
    const product = ann.ProductInformation?.[0]?.Description || '';

    rows.push({
      trainId,
      direction: toLocation,
      product,
      track,
      minsAdv,
      minsEst,
      delay: delayMins,
      isDelayed: delayMins >= 2,
      departures: [minsEst],
      lineNumber: trainId || product.slice(0, 4),
      category: 'TRAIN',
    });
  }

  return rows.sort((a, b) => a.minsEst - b.minsEst);
}
